/// <reference types="./advisoryLockDeleteExpired.d.ts" />
import { buildSqliteSqlQuery } from '@dossierhq/database-adapter';
import { queryMany } from '../QueryFunctions.js';
export async function advisoryLockDeleteExpired(database, context) {
    const now = Date.now();
    const query = buildSqliteSqlQuery(({ sql }) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        sql `DELETE FROM advisory_locks WHERE expires_at <= ${now} RETURNING name`;
    });
    return await queryMany(database, context, query);
}
//# sourceMappingURL=advisoryLockDeleteExpired.js.map